import React, { InputHTMLAttributes, useState } from 'react';

interface InputSearchProps extends InputHTMLAttributes<HTMLInputElement> {
    onClear?: () => void;
}

export const InputSearch = React.forwardRef<HTMLInputElement, InputSearchProps>(({
  className = '',
  onFocus,
  onBlur,
  onClear,
  ...props
}, ref) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  return (
    <div className="relative">
        <input
        ref={ref}
        onFocus={handleFocus}
        onBlur={handleBlur}
        className={`
            w-full
            px-4
            py-3
            pe-9
            bg-brand-bg-3
            rounded-xl
            placeholder:text-brand-color-2
            focus:outline-none
            ${isFocused ? '' : ''}
            ${className}
        `}
        {...props}
        />
        {onClear && props.value !== '' && (
            <button 
              className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-transparent hover:opacity-70 focus:outline-none flex flex-col text-[20px] p-2"
              onClick={() => onClear()}
              type="button"
            >
              <i className="material-icons">cancel</i>
            </button>
        )}
    </div>
    
  );
});

InputSearch.displayName = 'InputSearch';
